module.exports = __webpack_public_path__ + "static/img/robot-icon.61dae1ba.png";